import { Box, Chip, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { format, formatDistance } from "date-fns";
import * as React from "react";
import { FlightBridgeIntegration } from "./FlightBridgeStatus";

export const FlightBridgeStatusPresenter: React.FC<{
  integrations: FlightBridgeIntegration[];
}> = ({ integrations }) => {
  const columns: GridColDef[] = [
    {
      field: "fbo_name",
      headerName: "FBO",
      width: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "external_company_id",
      headerName: "Company ID",
      width: 150,
      editable: false,
      sortable: false,
    },
    {
      field: "sync_status",
      headerName: "Status",
      width: 125,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const status = params.row.sync_status || 'pending';
        let color: "success" | "error" | "warning" | "default" = "default";

        if (status === "success") color = "success";
        else if (status === "error") color = "error";
        else if (status === "pending") color = "warning";

        return (
          <Chip
            size="small"
            label={status.toUpperCase()}
            color={color}
          />
        );
      },
    },
    {
      field: "last_sync_at",
      headerName: "Last Sync",
      width: 250,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        if (!row.last_sync_at) {
          return "Never";
        }
        return format(
          new Date(row.last_sync_at),
          "yyyy-MM-dd hh:mm:ss a z"
        );
      },
    },
    {
      field: "last_sync_at_relative",
      headerName: "",
      width: 200,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        if (!row.last_sync_at) {
          return "";
        }
        return formatDistance(new Date(row.last_sync_at), new Date(), {
          addSuffix: true,
        });
      },
    },
    {
      field: "sync_error",
      headerName: "Error",
      width: 300,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        return row.sync_error || "";
      },
    },
  ];

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ height: "250px", width: "100%" }}
    >
      <Box>
        <Typography variant="subtitle2">FlightBridge Integrations</Typography>
        <Typography variant="body2" color="textSecondary">
          FlightBridge syncs trip schedules and concierge reservations from external flight operations systems.
          Each FBO integration syncs incrementally based on webhooks and scheduled updates.
        </Typography>
      </Box>
      <DataGrid
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableRowSelectionOnClick
        hideFooterPagination
        hideFooter
        rows={integrations}
        columns={columns}
        getRowId={(row) => row.fbo_id}
      />
    </Stack>
  );
};
